import React from "react";

const TableLoader = () => {
  return (
    <div class="spinner-border text-center" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  );
};

export default TableLoader;
